import React from "react";

export default function SQL_Self_Join() {
  return (
    <div className="p-4">
      <h1 className="text-2xl font-bold">SQL_Self_Join</h1>
      <p>This is the SQL_Self_Join component generated from the SQL JSON.</p>
    </div>
  );
}
